import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { HrefDirective } from '../../../directives/href/href.directive';
import { NotificationComponent } from '../../../components/notification/notification.component';
import { NotificationHeaderComponent } from '../../../components/notification/notification-header.component';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { InlineIconWrapperComponent } from '../../../features/inline-icon-wrapper/inline-icon-wrapper.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NotificationComponent,
    NotificationHeaderComponent,
    InlineIconWrapperComponent,
    HrefDirective,
    TranslatePipe,
    TranslateDirective
  ],
  selector: 'td-wb-w8ben-global-notification-banner',
  templateUrl: 'w8ben-global-notification-banner.component.html'
})
export class W8benGlobalNotificationBannerComponent {
  constructor() {}
}
